import React from "react";
import { connect } from "react-redux";
import { FORM_ID } from "../../../../../../constants";
import { Form, RootState } from "../../../../../../models";
import { FieldSet, FormRow, FormRowFormats, Input } from "../../../../forms";
import { Button, Select, Text } from "@telia/teddy";
import { VALIDATION_FIELD } from "../../../../rapidform/formValidation";
import { RapidForm } from "../../../../rapidform/index";
import { getFormById } from "../../../state/selectors";
import TEXT from "../../../text-consts";
import "./PersonalDetailsForm.less";
import { AddressState } from "../../../../../../models/state/teliaPlay";

interface StateProps {
    teliaPlayForm: Form;
}

interface PersonalDetailsFormProps extends StateProps {
    onSubmitDetails: () => void;
    availableAddresses: AddressState[];
    canShowAllAddresses: boolean;
    onShowAllAddresses: () => void;
    isApartmentLocked?: boolean;
    setSelectedApartment: (apartment: string) => void;
    selectedApartment: string;
}

const PersonalDetailsForm: React.FC<PersonalDetailsFormProps> = ({
    teliaPlayForm,
    onSubmitDetails,
    availableAddresses,
    canShowAllAddresses,
    onShowAllAddresses,
    isApartmentLocked = false,
    setSelectedApartment,
    selectedApartment,
}) => {
    return (
        <div className="telia-play-personal-details-form">
            <RapidForm
                id={FORM_ID.PERSONAL_DETAILS_TELIA_PLAY}
                action={"#"}
                errors={teliaPlayForm.errors}
                values={teliaPlayForm.values}
                visible={teliaPlayForm.visible}
                started={teliaPlayForm.started}
                onSubmit={onSubmitDetails}
            >
                <FieldSet name="details">
                    <Input
                        type="email"
                        name={VALIDATION_FIELD.PRODUCT_USER_EMAIL}
                        label={TEXT.PERSONAL_DETAILS.EMAIL}
                        disabled={false}
                        data-di-mask
                    />
                    <FormRow format={FormRowFormats.FIFTY_FIFTY}>
                        <div className="telia-play-personal-details-form-row">
                            <Input
                                type="tel"
                                name={VALIDATION_FIELD.PRODUCT_USER_PHONE}
                                label={TEXT.PERSONAL_DETAILS.PHONENUMBER}
                                disabled={false}
                                data-di-mask
                            />
                            <div className="telia-play-personal-details-form-apartment">
                                {availableAddresses &&
                                    (availableAddresses.length > 1 ||
                                        (canShowAllAddresses && availableAddresses.length > 0)) && (
                                        <Select
                                            maxHeight={200}
                                            label="Velg leilighet"
                                            onValueChange={(value) => {
                                                setSelectedApartment(value);
                                                return value;
                                            }}
                                            name="apartment"
                                            disabled={isApartmentLocked}
                                            options={availableAddresses.map((address) => address.apartment)}
                                            value={selectedApartment}
                                        >
                                            <Select.Trigger>
                                                <Select.Value placeholder="Velg leilighet">
                                                    {selectedApartment}
                                                </Select.Value>
                                            </Select.Trigger>
                                            <Select.Content>
                                                <Select.Viewport>
                                                    {availableAddresses.map((address) => (
                                                        <Select.Item key={address.apartment} value={address.apartment}>
                                                            {address.apartment}
                                                        </Select.Item>
                                                    ))}
                                                </Select.Viewport>
                                            </Select.Content>
                                        </Select>
                                    )}
                                {canShowAllAddresses && (
                                    <div className="telia-play-personal-details-form-show-all">
                                        <Button variant="text" type="button" onClick={onShowAllAddresses}>
                                            {isApartmentLocked
                                                ? TEXT.ADDRESSES.CHANGE_APARTMENT
                                                : TEXT.ADDRESSES.SHOW_ALL_APARTMENTS}
                                        </Button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </FormRow>
                </FieldSet>
                {availableAddresses && availableAddresses.length > 0 && (
                    <Text className="telia-play-personal-details-form-disclaimer">
                        For å kunne tilby nøyaktige priser og tjenester trenger vi å vite hvilken boenhet du bor i.
                    </Text>
                )}
            </RapidForm>
        </div>
    );
};

const mapStateToProps = (state: RootState): StateProps => ({
    teliaPlayForm: getFormById(state, "personalDetailsTeliaPlayForm"),
});

export default connect(mapStateToProps)(PersonalDetailsForm);
